import { content as contentApi } from '@/api';

import { CLASS_NAME } from '../constants';

const TABLE_PLACEHOLDER = '{{element}}';
const HTML_TABLE_TEMPLATE = `<p><table class="${CLASS_NAME.ASSURANCE_REPORT_TABLE}">${TABLE_PLACEHOLDER}</table></p>`;
const TABLE_ROW_TEMPLATE = `<tr>${TABLE_PLACEHOLDER}</tr>`;
const TABLE_HEADER_TEMPLATE = `<th>${TABLE_PLACEHOLDER}</th>`;
const TABLE_CONTENT_TEMPLATE = `<td>${TABLE_PLACEHOLDER}</td>`;

const MAX_COLUMN_NUMBER = 10;

function addAssuranceTable(assuranceReportJson) {
  const divide = `<hr class="${CLASS_NAME.HR_CLASS_NAME}"></hr>`;
  const blank = '<br></br>';
  let result = '';
  let headers = '';
  let contents = '';
  let rowIndex = 0;

  if (assuranceReportJson) {
    result = blank + divide + blank;

    Object.keys(assuranceReportJson).forEach((key, index) => {
      headers += TABLE_HEADER_TEMPLATE.replace(TABLE_PLACEHOLDER, key);
      contents += TABLE_CONTENT_TEMPLATE.replace(TABLE_PLACEHOLDER, assuranceReportJson[key]);

      if (
        index - rowIndex + 1 >= MAX_COLUMN_NUMBER ||
        index === Object.keys(assuranceReportJson).length - 1
      ) {
        const headerString = TABLE_ROW_TEMPLATE.replace(TABLE_PLACEHOLDER, headers);
        const contentString = TABLE_ROW_TEMPLATE.replace(TABLE_PLACEHOLDER, contents);

        const tableString = HTML_TABLE_TEMPLATE.replace(
          TABLE_PLACEHOLDER,
          headerString + contentString
        );

        if (index === Object.keys(assuranceReportJson).length - 1) {
          result += tableString;
        } else {
          result += tableString + blank;
        }

        headers = '';
        contents = '';
        rowIndex += index + 1;
      }
    });
  }

  return result;
}

function addNoDataString() {
  const divide = `<hr class="${CLASS_NAME.HR_CLASS_NAME}"></hr>`;
  const blank = '<br></br>';
  const noDataString = 'No Data Available';
  const headerString = TABLE_HEADER_TEMPLATE.replace(TABLE_PLACEHOLDER, noDataString);
  const rowString = TABLE_ROW_TEMPLATE.replace(TABLE_PLACEHOLDER, headerString);
  const tableString = HTML_TABLE_TEMPLATE.replace(TABLE_PLACEHOLDER, rowString);

  return blank + divide + blank + tableString;
}

async function loadAssuranceDocumentDetails(requestData, assuranceDetailsElement) {
  let assuranceResponse;

  try {
    assuranceResponse = await contentApi.getPageAssuranceDetails(
      requestData.moduleId,
      requestData.path
    );
  } catch (err) {
    console.error('Error while loading Assurance details: ', err);
  }

  if (
    assuranceResponse &&
    assuranceResponse.status === 200 &&
    assuranceResponse.data &&
    Object.prototype.hasOwnProperty.call(assuranceResponse.data, 'document')
  ) {
    if (assuranceResponse.data.document) {
      // eslint-disable-next-line no-param-reassign
      assuranceDetailsElement.innerHTML = addAssuranceTable(assuranceResponse.data.document);
    } else {
      // eslint-disable-next-line no-param-reassign
      assuranceDetailsElement.innerHTML = addNoDataString();
    }
  }
}

async function loadAssuranceDetailsOnScroll(requestData) {
  const assuranceDocumentDetails = document.getElementById('assuranceDocumentDetails');

  let lazyloadThrottleTimeout;
  // eslint-disable-next-line no-inner-declarations
  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }

  lazyloadThrottleTimeout = setTimeout(() => {
    const scrollTop = window.pageYOffset;

    if (assuranceDocumentDetails.offsetTop < window.innerHeight + scrollTop) {
      loadAssuranceDocumentDetails(requestData, assuranceDocumentDetails);
    }

    if (!assuranceDocumentDetails) {
      document.removeEventListener('scroll', loadAssuranceDetailsOnScroll(requestData));
      window.removeEventListener('resize', loadAssuranceDetailsOnScroll(requestData));
      window.removeEventListener('orientationChange', loadAssuranceDetailsOnScroll(requestData));
    }
  }, 20);
}

async function initializeLazyAssuranceDetails(requestData) {
  // Initiate the IntersectionObserver for lazy loading Assurance details.
  const assuranceDocumentDetails = document.getElementById('assuranceDocumentDetails');

  if (assuranceDocumentDetails) {
    if ('IntersectionObserver' in window) {
      const assuranceDocumentObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (assuranceDocumentObserver) {
              assuranceDocumentObserver.unobserve(entry.target);
            }
            loadAssuranceDocumentDetails(requestData, entry.target);
          }
        });
      });

      assuranceDocumentObserver.observe(assuranceDocumentDetails);
    } else {
      document.addEventListener('scroll', loadAssuranceDetailsOnScroll(requestData));
      window.addEventListener('resize', loadAssuranceDetailsOnScroll(requestData));
      window.addEventListener('orientationChange', loadAssuranceDetailsOnScroll(requestData));
    }
  }
}

async function loadAssuranceDetailsOnExport(requestData, doc) {
  const assuranceDocumentDetails = doc.getElementById('assuranceDocumentDetails');
  await loadAssuranceDocumentDetails(requestData, assuranceDocumentDetails);
}

export {
  addAssuranceTable,
  addNoDataString,
  loadAssuranceDocumentDetails,
  loadAssuranceDetailsOnScroll,
  initializeLazyAssuranceDetails,
  loadAssuranceDetailsOnExport
};
